var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',[_c('div',{staticClass:"row q-col-gutter-md"},[_c('div',{staticClass:"col col-xs-12 col-md-4 col-lg-5"},[_c('q-input',{attrs:{"label":_vm.$t('helps.table_titles.category.title'),"lazy-rules":"","error":_vm.categoryObj.errors.has('title'),"error-message":_vm.categoryObj.errors.get('title'),"rules":[ val => val && val.length > 0 || _vm.$t('helps.table_titles.category.title') + ' is required!']},model:{value:(_vm.categoryObj.title),callback:function ($$v) {_vm.$set(_vm.categoryObj, "title", $$v)},expression:"categoryObj.title"}})],1),_c('div',{staticClass:"col col-xs-12 col-md-4 col-lg-5"},[_c('q-input',{attrs:{"label":"Slug","lazy-rules":"","error":_vm.categoryObj.errors.has('slug'),"error-message":_vm.categoryObj.errors.get('slug'),"rules":[ val => val && val.length > 0 || _vm.$t('helps.table_titles.category.slug') + ' is required!']},model:{value:(_vm.categoryObj.slug),callback:function ($$v) {_vm.$set(_vm.categoryObj, "slug", $$v)},expression:"categoryObj.slug"}})],1),_c('div',{staticClass:"col col-xs-12 col-md-4 col-lg-2"},[_c('q-input',{attrs:{"label":_vm.$t('helps.table_titles.category.icon'),"lazy-rules":"","error":_vm.categoryObj.errors.has('icon'),"error-message":_vm.categoryObj.errors.get('icon'),"rules":[ val => val && val.length > 0 || _vm.$t('helps.table_titles.category.icon') + ' is required!']},model:{value:(_vm.categoryObj.icon),callback:function ($$v) {_vm.$set(_vm.categoryObj, "icon", $$v)},expression:"categoryObj.icon"}})],1),_c('div',{staticClass:"col col-xs-12"},[_c('div',[_vm._v(_vm._s(_vm.$t('helps.table_titles.category.description'))+":")]),_c('q-editor',{ref:"editor",attrs:{"dense":_vm.$q.screen.lt.md,"toolbar":[
            [
              {
                label: _vm.$q.lang.editor.align,
                icon: _vm.$q.iconSet.editor.align,
                fixedLabel: true,
                list: 'only-icons',
                options: ['left', 'center', 'right', 'justify']
              },
              {
                label: _vm.$q.lang.editor.align,
                icon: _vm.$q.iconSet.editor.align,
                fixedLabel: true,
                options: ['left', 'center', 'right', 'justify']
              }
            ],
            ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
            ['token', 'hr', 'link', 'custom_btn'],
            ['print', 'fullscreen'],
            [
              {
                label: _vm.$q.lang.editor.formatting,
                icon: _vm.$q.iconSet.editor.formatting,
                list: 'no-icons',
                options: [
                  'p',
                  'h1',
                  'h2',
                  'h3',
                  'h4',
                  'h5',
                  'h6',
                  'code'
                ]
              },
              {
                label: _vm.$q.lang.editor.fontSize,
                icon: _vm.$q.iconSet.editor.fontSize,
                fixedLabel: true,
                fixedIcon: true,
                list: 'no-icons',
                options: [
                  'size-1',
                  'size-2',
                  'size-3',
                  'size-4',
                  'size-5',
                  'size-6',
                  'size-7'
                ]
              },
              {
                label: _vm.$q.lang.editor.defaultFont,
                icon: _vm.$q.iconSet.editor.font,
                fixedIcon: true,
                list: 'no-icons',
                options: [
                  'default_font',
                  'arial',
                  'arial_black',
                  'comic_sans',
                  'courier_new',
                  'impact',
                  'lucida_grande',
                  'times_new_roman',
                  'verdana'
                ]
              },
              'removeFormat'
            ],
            ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

            ['undo', 'redo']
          ],"fonts":{
            arial: 'Arial',
            arial_black: 'Arial Black',
            comic_sans: 'Comic Sans MS',
            courier_new: 'Courier New',
            impact: 'Impact',
            lucida_grande: 'Lucida Grande',
            times_new_roman: 'Times New Roman',
            verdana: 'Verdana'
          }},model:{value:(_vm.categoryObj.description),callback:function ($$v) {_vm.$set(_vm.categoryObj, "description", $$v)},expression:"categoryObj.description"}}),(_vm.categoryObj.errors.has('description'))?_c('p',{staticClass:"text-negative"},[_vm._v("\n                "+_vm._s(_vm.categoryObj.errors.get('description'))+"\n            ")]):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }